import { Component, inject } from '@angular/core';
import { NotificationService } from '@core/services/notification';

@Component({
  selector: 'app-notifications',
  standalone: true,
  templateUrl: './notification.html',
})
export class NotificationComponent {
  private notificationService = inject(NotificationService);
  public messages = this.notificationService.messages;
}
